import http from './httpRequest.js'

export function getAutoReplyScripts() {
  return http({
    url: '/api/v1/customer/auto_reply_scripts',
    method: 'get'
  })
}

export function addAutoReplyScript(data) {
  return http({
    url: '/api/v1/customer/auto_reply_script',
    method: 'post',
    data
  })
}

export function updateAutoReplyScript(data) {
  return http({
    url: '/api/v1/customer/auto_reply_script',
    method: 'put',
    data
  })
}

export function deleteAutoReplyScript(data) {
  return http({
    url: '/api/v1/customer/auto_reply_script',
    method: 'delete',
    data
  })
}
